// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductLifestyle__container___ZiaqN layout__page-section-inset___1yxtJ layout__margin-auto___16OST","content":"ProductLifestyle__content___3r4Fw"};